<template>
    <el-select :multiple="multiple" :value="value" :value-key="type=='object'?'dicCode':''"  @visible-change="visiblechange"  @change="change" :size="size" :placeholder="placeholder" >
        <el-option
                v-for="item in list"
                :key="item.dicCode"
                :label="item.dicName"
                :value="type=='object'?item:item.dicCode">
        </el-option>
    </el-select>
</template>

<script>
    export default {
        name: "payment",
        props:{
            size:String,
            placeholder:String,
            multiple:Boolean,
            value:[Array,Object,String],
            type:String,
            memberpay:Boolean
        },
        model:{
            prop:'value'
        },
        data(){
            return{
                list:[],
                oldList:[]
            }
        },
        watch:{
            memberpay(newval,oldval){
                console.log(newval)
                if(!newval){
                    for(var i in this.list){
                        if(this.list[i].dicCode=='06'){
                            this.list.splice(i,1);
                            break;
                        }
                    }
                }else{
                    this.list=this.oldList;
                }
            }
        },
        mounted(){
            this.getData();
        },
        methods:{
            getData(){
                this.$axios.post("/dic/paymentCode/",{
                    "parentId": "1001",
                    "dicType": " paymentCode"
                }).then(res=>{
                    console.log(res.data.list)
                    this.oldList=res.data.list;
                    this.list=res.data.list;
                    if(!this.memberpay){
                        for(var i in this.list){
                            if(this.list[i].dicCode=='06'){
                                this.list.splice(i,1);
                                break;
                            }
                        }
                    }
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            visiblechange(isshow){
                if(isshow){
                    this.getData();
                }
            },
            change(value){
                console.log(value)
                this.$emit('input',value)
            }
        }
    }
</script>

<style scoped>

</style>